<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{ label }}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width client-autocomplete"
               remote
               :loading="loading"
               :placeholder="$t('generic.searchOrCreate')"
               :remote-method="onRemoteMethod"
               :value="value"
               clearable
               filterable
               default-first-option
               @change="onChange"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="emailTemplate in emailTemplates.data"
                 class="select-default"
                 :key="emailTemplate.id"
                 :label="emailTemplate.subject"
                 :value="emailTemplate.id">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import throttle from 'lodash/throttle'
import EmailTemplateService from 'src/services/EmailTemplateService'

export default {
  name: 'email-template-autocomplete',
  inheritAttrs: false,
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      loading: false,
      emailTemplates: {
        data: []
      }
    }
  },
  methods: {
    async searchEmailTemplates (query) {
      try {
        this.loading = true
        this.emailTemplates = await EmailTemplateService.get({query, limit: 50, ...this.searchParams})
      } catch (e) {
        console.warn(e)
      } finally {
        this.loading = false
      }
    },
    onChange (val) {
      this.$emit('change', val)
    },
  },
  created () {
    this.onRemoteMethod = throttle(this.searchEmailTemplates, 200)
  },
  async mounted () {
    await this.searchEmailTemplates(name)
  }
}
</script>
